<template>
  <div class="">
    <section class="bg-n3black text-white">
      <div class="sm:container sm:mx-auto">
        <BackButton />
        <div class="py-5">
          <component :is="summaryComponent"></component>
        </div>
      </div>
      <!-- ! Container end -->
    </section>
  </div>
</template>
<script>
import {
  computed,
  onMounted,
  reactive,
  toRefs,
  watch,
} from "@vue/runtime-core";
import SignIn from "@/views/auth/SignIn.vue";
import SignUp from "@/views/auth/SignUp.vue";
import Summary from "./components/Summary.vue";
import { useStore } from "vuex";
import BackButton from "@/components/button/BackButton.vue";
import { scrollToTop } from "@/utils/helper";
export default {
  name: "EventSummaryPage",
  components: { SignIn, SignUp, Summary, BackButton },
  setup() {
    const store = useStore();
    const state = reactive({
      event: computed(() => store.state.event.event),
      currentUser: computed(() => store.state.auth.currentUser),
      summaryComponent: computed(
        () => store.state.reservation.summaryComponent
      ),
    });
    watch(
      () => state.currentUser,
      () => {
        setComponent();
      }
    );
    onMounted(() => {
      scrollToTop();
      setComponent();
    });

    function setComponent() {
      store.dispatch("reservation/setState", {
        key: "summaryComponent",
        value: "Summary",
      });
    }

    return {
      ...toRefs(state),
    };
  },
};
</script>
